/*global showConfirmationBox */
$(function () {
    'use strict';
    $('.set-status-link').each(function () {
        var href = $(this).data('href'),
            checkbox = $(this),
            button,
            is_checked = checkbox.prop('checked');
        if (checkbox.data('true') && checkbox.data('false')) {
            checkbox.hide();
            button = $('<span class="set-status-button">');
            button.text(checkbox.data(is_checked.toString()));
            checkbox.before(button);
            button.on('click', function () {
                var is_checked,
                    data_submit = function (is_checked) {
                        checkbox.prop('checked', !is_checked).change();
                        button.text(checkbox.data((!is_checked).toString()));
                    };
                is_checked = checkbox.prop('checked');
                if (is_checked && checkbox.data('uncheck-confirm')) {
                    showConfirmationBox({
                        text: checkbox.data('uncheck-confirm'),
                        buttons: [
                            {
                                text: 'potwierd\u017a',
                                click: function () {
                                    $('#confirmation_box').remove();
                                    data_submit(is_checked);
                                }
                            },
                            'cancel'
                        ]
                    });
                } else {
                    data_submit(is_checked);
                }
            });
        }
        checkbox.on('change', function () {
            var is_checked = $(this).prop('checked');
            $.post(href, {'value': is_checked});
        });
    });

});



// WEBPACK FOOTER //
// ./weekly/static/js/set-status.js